// extracted by mini-css-extract-plugin
export default {"root":"IconCustomLocation_root__S1Z+w"};